import { asyncModalAdapter } from 'App/helpers/angularPortingHelpers';

export const openSendEmailAction = asyncModalAdapter({
	featureFlag: 'SEND_EAMIL_ACTION_REACT',
	upModalName: 'SendEmailAction',
	openModalName: 'SendEmailAction'
});
